import React from 'react';
import dayjs from 'dayjs';

const Frontmatter = ({ title, publishedAt, updatedAt }) => {
    return (
        <div>
            <h1 className="font-sans font-bold">{title}</h1>
            <div className="flex flex-row items-center gap-2 text-sm mt-2 text-secondary">
                <span>
                    Objavljeno: <span className="capitalize">{dayjs(publishedAt).format('MMMM YYYY')}</span>
                </span>
                <span>•</span>
                <span>Posodobljeno: {dayjs(updatedAt).fromNow()}</span>
            </div>
        </div>
    );
};

export default Frontmatter;
